/**
 * Revela com fade + slide (Sessão 6 da página Nossa História, único card com
 * animação) quando a seção entra na tela. Só afeta seções com
 * data-bdl-scroll-reveal — Sessões 4 e 5 reaproveitam o mesmo section file
 * (bdl-historia-card.liquid) sem esse atributo e não são tocadas aqui.
 *
 * Enhancement progressivo: o CSS deixa tudo visível por padrão. Quando o card
 * entra na viewport, o JS adiciona a classe que inicia a animação. Sem JS, sem
 * observer, ou com prefers-reduced-motion, o conteúdo aparece pronto — nunca
 * fica escondido por engano.
 */
const revealTargets = document.querySelectorAll('[data-bdl-scroll-reveal]');

if (revealTargets.length > 0 && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bdl-historia-card--pending');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.01 }
  );

  revealTargets.forEach((el) => observer.observe(el));
}
